import { compileErrorContext, implementNode } from "../shared/implement.js";
import { BaseProp, intersectProps } from "./prop.js";
export class RequiredNode extends BaseProp {
    expression = `${this.compiledKey}: ${this.value.expression}`;
    errorContext = Object.freeze({
        code: "required",
        missingValueDescription: this.value.description,
        relativePath: [this.key]
    });
    compiledErrorContext = compileErrorContext(this.errorContext);
}
export const requiredImplementation = implementNode({
    kind: "required",
    hasAssociatedError: true,
    intersectionIsOpen: true,
    keys: {
        key: {},
        value: {
            child: true,
            parse: (schema, ctx) => ctx.$.schema(schema)
        }
    },
    normalize: schema => schema,
    defaults: {
        description: node => `${node.compiledKey}: ${node.value.description}`,
        expected: ctx => ctx.missingValueDescription,
        actual: () => "missing"
    },
    intersections: {
        required: intersectProps,
        optional: intersectProps
    }
});
